
import { runEventAnalyzer } from './AnalyzerFunctions'; // wherever you put it

export function testAnalyzer(currentUser, allEvents, currentEventId = null) {
    const result = runEventAnalyzer({
        currentUser,
        allEvents,
        currentEventId
    });

    console.groupCollapsed('%c🔍 Analyzer Result', 'color: #1976d2; font-weight: bold');
    console.log(result);
    console.groupEnd();

    const { tier, qualifiedEventCount, eventCount, aiConcierge } = result;

    return result;
}
